import { ExtDate } from '@/helpers/date';

export default {
  computesRequired: true,
  validate: (value) => {
    let valid = true;
    if (!value) valid = false;
    const birthDate = new ExtDate(value);
    if (!birthDate.isValid()) valid = false;

    return {
      valid,
      required: true,
    };
  },
  message: (fieldName, { _value_: v }) => {
    const defaultMsg = 'Please enter the date.';
    if (!v) return defaultMsg;
    const birthDate = new ExtDate(v);
    if (!birthDate.isValid()) return 'Invalid format for date of birth.';
    return defaultMsg;
  },
};
